module.exports = __webpack_public_path__ + "img/couples-018.65633972.jpg";